export const XSRFHeader = "X-Hourglass-XSRF-Token";
export const baseUrl = "/api/v0.2";
export const fsReportUrl = "fsreport";
export const circuitUrl = "circuit";
export const schedulingUrl = "scheduling";
export const smpwUrl = "smpw";
export const UnknownCharacter = "\uFFFD";
